import { render, staticRenderFns } from "./RegisteredEventsTab.vue?vue&type=template&id=3724544f&scoped=true&"
import script from "./RegisteredEventsTab.vue?vue&type=script&lang=js&"
export * from "./RegisteredEventsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724544f",
  null
  
)

export default component.exports